
import React, { Component } from 'react';
import '../App.css';

class SessionComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {

    };


  }

  componentWillMount(){

  }


  render() {
    return (
      <div className="session">
        <p className="text">{this.props.text}</p>
      </div>
    );
  }
}

export default SessionComponent;



// WEBPACK FOOTER //
// ./src/components/sessionComponent.js